module.exports = __webpack_public_path__ + "static/media/Account.a7f63b05.svg";